var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5V27C30 28.6569 28.6569 30 27 30H5C3.34312 30 2 28.6569 2 27V5C2 3.34312 3.34312 2 5 2H27C28.6569 2 30 3.34312 30 5ZM21 18.5C20.0899 18.5 19.2611 18.8476 18.6386 19.4169L14.3912 16.8685C14.5362 16.2986 14.5362 15.7014 14.3912 15.1314L18.6386 12.583C19.2611 13.1524 20.0899 13.5 21 13.5C22.933 13.5 24.5 11.933 24.5 10C24.5 8.067 22.933 6.5 21 6.5C19.067 6.5 17.5 8.067 17.5 10C17.5 10.2998 17.5378 10.5908 17.6088 10.8686L13.3614 13.417C12.7389 12.8476 11.9101 12.5 11 12.5C9.067 12.5 7.5 14.067 7.5 16C7.5 17.933 9.067 19.5 11 19.5C11.9101 19.5 12.7389 19.1524 13.3614 18.5831L17.6088 21.1315C17.5364 21.4153 17.4999 21.7071 17.5001 22.0001C17.5001 23.9331 19.0671 25.5001 21.0001 25.5001C22.9331 25.5001 24.5001 23.9331 24.5001 22.0001C24.5 20.067 22.933 18.5 21 18.5Z",
    fill: "#079E88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGreen);
export default __webpack_public_path__ + "static/media/share-green.4643d6f42c7c8f2c3530d0991683696c.svg";
export { ForwardRef as ReactComponent };